import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


const PendingFloraPlates =  async (page :number, pageSize :number,area_id: string, activityType: string, keyWord: string,sort:any,order:any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plate_environmental_flora/list_plates_for_flora?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active&lab_area_id=${area_id}&keyword=${keyWord}&master_activities_id=${activityType}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const PendingLabtestPlates =  async (page :number, pageSize :number, batchCode: string, keyWord: string, status:string,sort:any,order:any, scheduleProductId?: string, productId?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/plates/list_plates_for_lab_test?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active&batch_number=${batchCode}&keyword=${keyWord}&lab_qa_status=${status}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const scanEnvironmentFloraById = async (dataToSend :any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/plate_environmental_flora/check_plate_for_flora`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listShapesOptions =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_colony_shapes?sort=shape_name&order=asc&status=active`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listColorOptions =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_colony_colors?sort=colony_colour&order=asc&status=active`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listTypeOptions =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_organism_types?sort=organism_type&order=asc&status=active`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listGenusOptions =  async (type_id: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_colony_genus?sort=organism_type&order=asc&status=active&organism_type_id=${type_id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listSpeciesOptions =  async (type_id: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_colony_species?sort=organism_type&order=asc&status=active&genus_id=${type_id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listStrainOptions =  async (type_id: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_colony_strain?sort=organism_type&order=asc&status=active&species_id=${type_id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const saveEnvironmentFlora = async (dataToSend : any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/plates/save_plate_environmental_flora_details`, 
     dataToSend,
     {
       headers: {
         'x-auth-token': authToken,
         'x-userid': authUserID
       }
     }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const HistoryFloraPlates =  async (page :number, pageSize :number,area_id: string, keyWord:any,sort:any,order:any,scheduleProductId?: string, productId?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stat_activity/environmental_flora_history?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active&lab_area_id=${area_id}&keyword=${keyWord}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}





const floraServices = {

    PendingFloraPlates,
    PendingLabtestPlates,
    scanEnvironmentFloraById,
    listShapesOptions,
    listColorOptions,
    listTypeOptions,
    listGenusOptions,
    listSpeciesOptions,
    listStrainOptions,
    saveEnvironmentFlora,
    HistoryFloraPlates,

  };
  
  export { floraServices };